import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const userAuthApi = createApi({
  reducerPath: "userAuthApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    registerQuery: builder.mutation({
      query: (user) => {
        return {
          url: "auth/register",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json",
          },
        };
      },
    }),
    loginQuery: builder.mutation({
      query: (user) => {
        return {
          url: "auth/login",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json",
          },
        };
      },
    }),
    logoutQuery: builder.mutation({
      query: ({token}) => {
        return {
          url: "auth/logout",
          method: "POST",
          body: {},
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
        };
      },
    }),
    getLoggedUser: builder.query({
      query: ({token}) => {
        return {
          url: 'users/show-list',
          method: 'POST',
          body: {},
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          }
        }
      }
    }),
    getSingleTenderDetail: builder.query({
      query: ({token ,tenderId}) => {
        return {
          url: `content/tender-detail/${tenderId}`,
          method: 'GET',
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          }
        }
      }
    }),
    uploadSupplierAttachment: builder.mutation({
      query: (data) => {
        return {
          url: 'apply-tender',
          method: 'POST',
          body: data.formData,
          formData: true,
          headers: {
            'Authorization': `Bearer ${data.token}`,
          }
        }
      }
    }),
    getPagesAccess: builder.query({
      query: ({token}) => {
        return {
          url: 'content/access-pages',
          method: 'GET',
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          }
        }
      }
    }),
    getHomePageDetail: builder.query({
      query: (language) => {
        return {
          url: `content/home-page/${language}`,
          method: 'GET',
          headers: {
            "Content-type": "application/json",
          }
        }
      }
    }),
    getTenderList: builder.query({
      query: () => {
        return {
          url: 'content/tenders',
          method: 'GET',
          headers: {
            "Content-type": "application/json",
          }
        }
      }
    }),
    sendResetLinkEmail: builder.mutation({
      query: ({email ,lang}) => {
        return {
          url: "password/email",
          method: "POST",
          body: {email,lang},
          headers: {
            "Content-type": "application/json",
          }
        }
      }
    }),
    resetPassword: builder.mutation({
      query: (data) => {
        return {
          url: "password/reset",
          method: "POST",
          body: data.formData,
          formData: true
        }
      }
    }),
    getBrochureList: builder.query({
      query: () => {
        return {
          url: 'content/brochure-list',
          method: 'GET',
          headers: {
            "Content-type": "application/json",
          }
        }
      }
    }),
    contactUsQuery: builder.mutation({
      query: (user) => {
        return {
          url: "contact/contact-us",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json",
          },
        };
      },
    }),
    getNewsRoomDetail: builder.query({
      query: (language) => {
        return {
          url: `content/getNewRoomImages`,
          method: 'GET',
          headers: {
            "Content-type": "application/json",
          }
        }
      }
    }),
    getGalleryImagesDetail: builder.query({
      query: (language) => {
        return {
          url: `content/getGalleryImages`,
          method: 'GET',
          headers: {
            "Content-type": "application/json",
          }
        }
      }
    }),
    getFormConfig: builder.query({
      query: (formType) => {
        return {
          url: `form-config/${formType}`,
          method: 'GET',
          headers: {
            "Content-type": "application/json",
          }
        }
      }
    }),
    getPetOwnerProfile: builder.query({
      query: ({token}) => {
        return {
          url: 'profile',
          method: 'GET',
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          }
        }
      }
    }),
    updateUserProfile: builder.mutation({
      query: ({token, data}) => {
        return {
          url: 'profile',
          method: 'PUT',
          body: data,
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          }
        }
      }
    }),
    getUserPets: builder.query({
      query: ({token}) => {
        return {
          url: 'pets',
          method: 'GET',
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          }
        }
      }
    }),
    addPet: builder.mutation({
      query: ({token, petData}) => {
        return {
          url: 'pets',
          method: 'POST',
          body: petData,
          headers: {
            "Content-type": "application/json",
            'Authorization': `Bearer ${token}`,
          }
        }
      }
    }),
  }),
});

export const {
  useRegisterQueryMutation,
  useLoginQueryMutation,
  useLogoutQueryMutation,
  useGetLoggedUserQuery,
  useGetSingleTenderDetailQuery,
  useUploadSupplierAttachmentMutation,
  useGetPagesAccessQuery,
  useGetHomePageDetailQuery,
  useGetTenderListQuery,
  useSendResetLinkEmailMutation,
  useResetPasswordMutation,
  useGetBrochureListQuery,
  useContactUsQueryMutation,
  useGetNewsRoomDetailQuery,
  useGetGalleryImagesDetailQuery,
  useGetFormConfigQuery,
  useGetPetOwnerProfileQuery,
  useUpdateUserProfileMutation,
  useGetUserPetsQuery,
  useAddPetMutation
} = userAuthApi;